module.exports = __webpack_public_path__ + "img/a-ziyuan18.8738365d.png";